import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useStudents from "../../../../hooks/useStudents";
import { TableSkeleton } from "../../../../components/TableSkeleton";

export default function CertificateDialog({ open, onClose,verify, studentId, skipApiCall, certificateUrl, isLoadingCertificates }) {
    const [pdfUrl, setPdfUrl] = useState(null);
    const [isError, setIsError] = useState(false);
      
    
    const handleDownload = () => {
        if (!pdfUrl) return;

        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = `Certificate-${studentId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>
                View Certificate
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {isLoadingCertificates ? (
                    <TableSkeleton />
                ) : isError ? (
                    <p style={{ color: "red" }}>Error loading certificate. Please try again later.</p>
                ) : certificateUrl ? (
                    <iframe
                        src={certificateUrl}
                        title="Certificate PDF"
                        width="100%"
                        height="600px"
                        style={{ border: "1px solid #ccc", borderRadius: "4px" }}
                    />
                ) : (
                    <p>No certificate available.</p>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} sx={{ fontSize: 14, color: "#454751d1" }}>
                    Cancel
                </Button>
                {!verify && <Button
                    sx={{ fontSize: 14, background: "#454751d1" }}
                    onClick={handleDownload}
                    variant="contained"
                    disabled={!pdfUrl}
                >
                    Download
                </Button>}
            </DialogActions>
        </Dialog>
    );
}